import React, { useState } from "react";
import styled from "styled-components";
import helpData from "../../data/Help";
import { COLORS } from "../../assets/colors";
function HelpSection() {
  const [textLen, setTextLen] = useState(245);
  const [currentId, setCurrentId] = useState();
  const handleShowMore = (item) => {
    setCurrentId(item.id);
  };
  return (
    <Container>
      <div className="heading">
        <h2>GoSawari Help Centre</h2>
      </div>
      <div className="innerContainer">
        {helpData.map((item, key) => {
          return (
            <div className="helpItem" key={key}>
              <h3>{item.title} </h3>
              <p>
                {item.description.substring(
                  0,
                  currentId === item.id ? item.description.length : textLen
                )}{" "}
                {currentId !== item.id &&
                  item.description.length > textLen &&
                  "..."}
              </p>
              {item.description.length > textLen && currentId != item.id && (
                <p onClick={() => handleShowMore(item)}>read more</p>
              )}
            </div>
          );
        })}
      </div>
    </Container>
  );
}

export default HelpSection;

const Container = styled.div`
  padding: 5rem 2rem;
  height: auto;
  background-color: ghostwhite;

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 2rem 1rem;
  }

  .heading {
    display: flex;
    justify-content: center;
      h2 {
        text-align: center;
        color: rgb(5, 71, 82);
        font-weight: 700;
        padding-bottom: 3rem;
        padding-top: 2rem;
        font-size: 2.5rem;
        letter-spacing: -0.5px;

        @media (max-width: 768px) {
          font-size: 1.8rem;
          padding-bottom: 2rem;
          padding-top: 1rem;
          line-height: 1.25;
        }

        @media (max-width: 480px) {
          font-size: 1.6rem;
        }
      }
  }

  .innerContainer {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    align-items: flex-start;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .helpItem {
    width: 48%;
    display: flex;
    flex-direction: column;
    padding: 1.5rem 0;
    border-bottom: 1px solid ${COLORS.borderColor};

    @media (max-width: 768px) {
      width: 100%;
    }

    h3 {
      margin-bottom: 1rem;
      font-weight: 600;
      color: ${COLORS.primaryTextColor};
      font-size: 1.25rem;

      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }

    p {
      color: ${COLORS.secondaryTextColor};
      line-height: 1.6;
      text-align: left;
      font-size: 1rem;

      @media (max-width: 768px) {
        font-size: 0.95rem;
      }

      &:nth-child(3) {
        color: #00b5ff !important;
        align-self: flex-end;
        margin-top: 0.5rem;
        cursor: pointer;
        font-weight: 600;
        font-size: 0.9rem;
      }
    }
  }
`;